/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/pages/auth/AuthPage`, `src/pages/home/HomePage`).
 */

import React from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import { AdminProvider } from 'contexts/AdminContext'
import ErrorsPage from 'pages/errors/ErrorsPage'
import LogoutPage from 'pages/auth/Logout'
import { LayoutContextProvider } from '_metronic'
import { ZariProvider } from '_zari/context'
import Layout from '_metronic/layout/Layout'
import AuthPage from 'pages/auth/AuthPage'
import HomePage from 'pages/home'

import AlmacenesPage from 'pages/almacenes'
import CategoriasPage from 'pages/categorias'
import CobranzasPage from 'pages/cobranzas'
import CompaniasPage from 'pages/companias'
import ComprasPage from 'pages/compras'
import ComprasIngresoGuiaPage from 'pages/compras-ingresoGuia'
import ComputerPage from 'pages/computer'
import ConsultasPage from 'pages/consultas'
import BackgroundJobsPage from 'pages/backgroundJobs'
// import CotizacionesPage from 'pages/cotizaciones'
import DarDeBajaPage from 'pages/darDeBaja'
import EgresosIngresosPage from 'pages/egresos-ingresos'
import EmisorDocumentosPage from 'pages/emisorDocumentos'
import FamiliasPage from 'pages/familias'
// import FormulasPage from 'pages/formulas'
import InventariosEntradaSalidaPage from 'pages/inventarioEntradaSalida'
import InventariosFisicoPage from 'pages/inventarioFisico'
import IngresoAlmacenOrdenComprasPage from 'pages/ingreso-almacen-orden-compra'
import IslasPage from 'pages/islas'
import MarcasPage from 'pages/marcas'
import OrdenesCompraPage from 'pages/ordenesCompra'
import OrdenesCompraAprobacionPage from 'pages/ordenesCompraAprobacion'
// import OrdenesCompraCambioEstadoPage from 'pages/ordenesCompraCambioEstado'
// import PedidosPage from 'pages/pedidos'
import PlantillaCabeceraPiePage from 'pages/plantillasCabeceraPie'
import PreFacturacionesPage from 'pages/preFacturaciones'
import PreciosPage from 'pages/precios'
import ProductosPage from 'pages/productos'
import PromocionesPage from 'pages/promociones'
import RequerimientosPage from 'pages/requerimientos'
import AlmacenGestionPage from 'pages/almacenGestion'
import RolesPage from 'pages/roles'
import SaldosInicialesPage from 'pages/saldosIniciales'
import SedesPage from 'pages/sedes'
import SelfPage from 'pages/self'
import SeriesPage from 'pages/series'
import SociosPage from 'pages/socios'
import SociosSeguimientoPage from 'pages/socios-seguimiento'
import SubFamiliasPage from 'pages/subFamilias'
import TablasComunesPage from 'pages/tablasComunes'
import TablasPersonalizadasPage from 'pages/tablasPersonalizadas'
import TalleresPage from 'pages/talleres'
import TransaccionesPage from 'pages/transacciones'
import TransferenciasPage from 'pages/transferencias'
import TurnosPage from 'pages/turnos'
import UbicacionesAlmacenamientoPage from 'pages/ubicacionesAlmacenamiento'
import UsuariosPage from 'pages/usuarios'
import VentasPage from 'pages/ventas'
import VentasConsultasGuiasPage from 'pages/ventas-consultaGuias'
import VentasConsultasVentasPage from 'pages/ventas-consultaVentas'
import VentasDesvincularAnticipoPage from 'pages/ventas-desvincularAnticipo'
import VentasIngresoGuiaPage from 'pages/ventas-ingresoGuia'
import VentasIngresoGuiaYaEmitidasPage from 'pages/ventas-ingresoGuia-yaEmitidas'
import ProvisionesPage from 'pages/provisiones'

export const Routes = withRouter(() => {
  // const { menuConfig } = useSelector(({ auth, urls, builder: { menuConfig } }) => {
  //   return {
  //     menuConfig
  //   }
  // }, shallowEqual)

  const isAuthorized = !!window.localStorage.getItem('token')

  return (
    <LayoutContextProvider>
      <ZariProvider>
        <Switch>
          {!isAuthorized ? (
            <AuthPage />
          ) : (
            /* Otherwise redirect to root page (`/`) */
            <Redirect from='/auth' to='/' />
          )}

          <Route path='/error' component={ErrorsPage} />
          <Route path='/logout' component={LogoutPage} />

          {!isAuthorized ? (
            /* Redirect to `/auth` when user is not authorized */
            <Redirect to='/auth/login' />
          ) : (
            <AdminProvider>
              <Layout>
                <AlmacenesPage />
                <CategoriasPage />
                <CobranzasPage />
                <CompaniasPage />
                <ComprasPage />
                <ComprasIngresoGuiaPage />
                <BackgroundJobsPage />
                <ConsultasPage />
                <ComputerPage />
                {/* <CotizacionesPage /> */}
                <DarDeBajaPage />
                <EgresosIngresosPage />
                <EmisorDocumentosPage />
                <FamiliasPage />
                {/* <FormulasPage /> */}
                <InventariosEntradaSalidaPage />
                <InventariosFisicoPage />
                <IngresoAlmacenOrdenComprasPage />
                <IslasPage />
                <MarcasPage />
                <OrdenesCompraPage />
                <OrdenesCompraAprobacionPage />
                {/* <OrdenesCompraCambioEstadoPage /> */}
                {/* <PedidosPage /> */}
                <PlantillaCabeceraPiePage />
                <PreFacturacionesPage />
                <PreciosPage />
                <ProductosPage />
                <PromocionesPage />
                <ProvisionesPage />
                <RequerimientosPage />
                <AlmacenGestionPage />
                <RolesPage />
                <SaldosInicialesPage />
                <SedesPage />
                <SelfPage />
                <SeriesPage />
                <SociosPage />
                <SociosSeguimientoPage />
                <SubFamiliasPage />
                <TablasComunesPage />
                <TablasPersonalizadasPage />
                <TalleresPage />
                <TransaccionesPage />
                <TransferenciasPage />
                <TurnosPage />
                <UbicacionesAlmacenamientoPage />
                <UsuariosPage />
                <VentasPage />
                <VentasConsultasGuiasPage />
                <VentasConsultasVentasPage />
                <VentasDesvincularAnticipoPage />
                <VentasIngresoGuiaPage />
                <VentasIngresoGuiaYaEmitidasPage />
                <Switch>
                  <Route path='/' component={HomePage} />
                  <Redirect to='/error/error-v1' />
                </Switch>
              </Layout>
            </AdminProvider>
          )}
        </Switch>
      </ZariProvider>
    </LayoutContextProvider>
  )
})
